var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-arrow",class:_vm.setDirection})
}
var staticRenderFns = []

export { render, staticRenderFns }